import { useCallback } from 'react';
import { UUID } from 'v2/core/entities/uuid';
import { WhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { QBNode } from 'v2/querybuilder/types/qbNode';
import fromWhereClause from './fromWhereClause';

export const useFromWhereClause = () => {
  return useCallback((where: WhereClause, parent?: UUID): QBNode => {
    return fromWhereClause(where, parent);
  }, []);
};
